import { IAppState } from '../../common/state';

export function selectSpecialPromoSecondaryOffers(state: IAppState) {
  return state.specialPromoSecondaryOffers;
}
